if ('undefined' === typeof vtx_login) {
  console.warn('Missing nonce.');
  vtx_login = {
    nonce: ''
  };
}
(function ($) {
  var app_id = 'member-login-app';
  function update_login_field_state($field) {
    var $input = $field.find('input');
    var value = $input.val();
    if ('' === value) {
      $field.removeClass('active');
    } else {
      $field.addClass('active');
    }
  }
  function init_events_login_field($field) {
    $field.on('change', function () {
      update_login_field_state(this);
    }.bind($field));
    $field.on('focusin', 'input', function () {
      this.addClass('active');
    }.bind($field));
    $field.on('focusout', 'input', function () {
      update_login_field_state(this);
    }.bind($field));
  }
  function init_login_fields() {
    var $login_app = $('#' + app_id);
    $login_app.find('.login__field-group').each(function () {
      var $field = $(this);
      update_login_field_state($field);
      init_events_login_field($field);
    });
  }
  Vue.createApp({
    data: function data() {
      return {
        current_vue: 'login',
        form_username: '',
        form_password: '',
        form_password_1: '',
        form_password_2: '',
        form_first_name: '',
        form_last_name: '',
        form_email: '',
        hide_form: false,
        message: '',
        is_loading: false,
        is_successful: false
      };
    },
    computed: {},
    methods: {
      displayVue: function displayVue(vue_name) {
        this.hide_form = false;
        this.message = '';
        if ('login' === vue_name) {
          this.user = [];
          this.current_vue = 'login';
        } else if ('forgot_password' === vue_name) {
          this.user = [];
          this.current_vue = 'forgot_password';
        }
      },
      submitLogin: function submitLogin(redirectUrl) {
        var _this = this;
        if (this.form_username.length > 0 && this.form_password.length > 0) {
          this.is_loading = true;
          this.message = '';
          fetch('/wp-json/rest_login/login/', {
            method: 'POST',
            headers: {
              'X-WP-Nonce': vtx_login.nonce,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              'username': this.form_username,
              'password': this.form_password
            })
          }).then(function (res) {
            return res.json();
          }).then(function (res) {
            _this.is_loading = false;
            if (res.message.length > 0) {
              _this.message = res.message;
            }
            if (200 === res.code) {
              // If the login is successful
              _this.hide_form = true;
              _this.is_successful = true;
              if (redirectUrl) {
                window.location.href = redirectUrl;
                _this.message += ' ' + _x('Redirecting...', 'Appent login success message', 'vtx');
              }
            }
          });
        } else {
          this.message = 'Champ username ou password vide';
        }
      },
      submitPasswordReset: function submitPasswordReset() {
        var _this2 = this;
        this.is_loading = true;
        this.message = '';
        fetch('/wp-json/rest_login/reset_password/', {
          method: 'POST',
          headers: {
            'X-WP-Nonce': vtx_login.nonce,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            'username': this.form_username
          })
        }).then(function (res) {
          return res.json();
        }).then(function (res) {
          _this2.is_loading = false;
          if (res.message.length > 0) {
            _this2.message = res.message;
          }
          if (200 === res.code) {
            _this2.hide_form = true;
          }
        });
      },
      resetForm: function resetForm() {
        this.form_username = '';
        this.form_first_name = '';
        this.form_last_name = '';
        this.form_email = '';
      },
      initFields: function initFields() {
        init_login_fields();
      }
    },
    mounted: function mounted() {
      document.getElementById(app_id).classList.remove('hide-until-loaded');
      if (typeof wp_message !== 'undefined' && wp_message !== null && wp_message.length > 0) {
        this.message = wp_message;
      }
      init_login_fields();
    }
  }).mount('#' + app_id);
})(jQuery);